
<mat-card class="card-section" *ngIf="!loginDisplay">
    <mat-card-title>Supply Ontario Work Request Intake</mat-card-title>
    <mat-card-subtitle>Sign-in with Azure AD</mat-card-subtitle>
    <mat-card-content></mat-card-content>
</mat-card>
<mat-card class="action-card-section">
<mat-expansion-panel class="card-container" *ngIf="showNewFeatures()">
    <mat-expansion-panel-header>
        <mat-title><b>New Features</b></mat-title>
    </mat-expansion-panel-header>
    <mat-card class="card-container">
        <mat-card-content>
            
            The following features have been added an 21, 2025:
            <br>
            <hr>
            <b>Project Dash Board</b>
            <ul>
                <li>A new filter to select by Project(s).</li>
                <li>The browser URL is now actively updated with the filter selections, allowing for a stateful bookmark.</li>
            </ul>
            <b>Project Status Report</b>
            <ul>
                <li>A button to download the status report to PDF.</li>
                <li>A date selector that allows the user to see the version history of the status report based on a prior date.</li>
            </ul>
            
        </mat-card-content>
    </mat-card>

</mat-expansion-panel>
</mat-card>
<mat-card class="action-card-section" *ngIf="loginDisplay">
    <mat-card-title>

    </mat-card-title>
    <mat-card-content>
        <div *ngIf="userType.isUser" class="row">
            <div class="col-md-4">
                <mat-card role="button" tabindex="0" class="card-section-sm"
                    routerLink="../work-request/new/{{globalConstants.REQUEST_TYPE_WORK_ORDER}}">
                    <mat-card-title>Create IT Work Order
                    </mat-card-title>
                    <mat-card-content>
                        <img class="work-order-img" ngSrc="assets/work-order-request-icon.png" alt="work request icon" height="587"
                             width="526">
                        <p>{{instruction.workorder}}</p>
                    </mat-card-content>

                </mat-card>
            </div>

            <div class="col-md-4">
                <mat-card role="button" tabindex="0" class="card-section-sm"
                    routerLink="../work-request/new/{{globalConstants.REQUEST_TYPE_CONSULTATION}}">
                    <mat-card-title>Create IT Consultation/Query
                    </mat-card-title>
                    <mat-card-content>
                        <img class="request-img" ngSrc="assets/consultation-request-icon.png" alt="consulation icon"
                             height="866" width="860">
                        <p>{{instruction.consultation}}</p>
                    </mat-card-content>
                </mat-card>
            </div>
            <!--div class="offset-md-2 col-md-8"-->

            <div class="col-md-4">    
                <mat-card role="button" tabindex="0" class="card-section-sm"
                    routerLink="../work-request/new/{{globalConstants.REQUEST_TYPE_PROJECT}}">
                    <mat-card-title>Create IT Project
                    </mat-card-title>
                    <mat-card-content>
                        <img class="project-img" ngSrc="assets/project-request-icon.png" alt="project icon" height="512"
                             width="512">
                        <p>{{instruction.project}}</p>
                    </mat-card-content>
                </mat-card>
            </div>
            <div class="col-md-6">    
                <mat-card role="button" tabindex="0" class="card-section-sm"
                    (click)="goToCouldRequest()">
                
                    <mat-card-title>Cloud Intake Request
                    </mat-card-title>
                    <mat-card-content>
                        <img class="cloud-img" ngSrc="assets/cloud-icon.png" alt="project icon" height="512"
                             width="512">
                        <p>{{instruction.cloudRequest}}</p>
                    </mat-card-content>
                </mat-card>
            </div>
            <div class="col-md-6">    
                <mat-card role="button" tabindex="0" class="card-section-sm"
                    (click)="goToACERequest()">
                
                    <mat-card-title>Application Onboarding Template (ACE) 
                    </mat-card-title>
                    <mat-card-content>
                        <img class="ace-img" ngSrc="assets/ace-icon.png" alt="project icon" height="512"
                             width="512">
                        <p innerHTML="{{instruction.aceTemplate}}"></p>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
        <mat-card-footer>
            {{globalConstants.RETURN_RESPONSE_MSG}}
        </mat-card-footer>
    </mat-card-content>
    <mat-card-footer>
    </mat-card-footer>
</mat-card>
<mat-card class="card-section-other" *ngIf="loginDisplay">
    <mat-card-title class="col-md-12"><b>Other Related Services</b>
        <br> <br>
    </mat-card-title>
    <mat-card-content>
        <div class="row">
            <div class="col-md-6">
                <mat-card role="button" tabindex="0" class="card-section-sm" (click)="goToOPSServiceCenter()">
                    <mat-card-title><img class="sc-icon" ngSrc="assets/ops-service-center-icon.png" alt="onRequest icon"
                        height="30" width="250">
                    </mat-card-title>
                    <mat-card-content>
                        The OPS Service Centre can assist with issues related to your mobile and desktop equipment and
                        account. (must be on VPN)
                        <br><br>
                        Toll free: 1-888-996-OPSSC (1-888-996-7772)
                        <br>
                        GTA: 416-915-7772
                        <br>
                        Adaptive Technology Services (IT – TTY): 1-888-677-4873 or
                        <br>
                        (OSS Business Services – TTY) 866-310-7259
                    </mat-card-content>
    
                </mat-card>
            </div>
            <div class="col-md-6">
                <mat-card role="button" tabindex="0" class="card-section-sm" (click)="goToOnRequest()">
                    <mat-card-title> <img class="onrequest-icon" ngSrc="assets/onRequest-icon.png" alt="onRequest icon"
                            height="40" width="185">
                    </mat-card-title>
                    <mat-card-content>
                         Submit requests for software licenses and installations. This requires manager approval prior to submitting request. (must be on VPN)
    
                    </mat-card-content>
    
                </mat-card>
            </div>
        </div>
    </mat-card-content>
</mat-card>
<mat-card class="card-section" *ngIf="loginDisplay">

    <mat-card-title class="col-md-12"><b>Application Overview</b>
        <br> <br>
    </mat-card-title>
    <mat-card-content>
        <div class="row">
            <div *ngIf="userType.isUser" class="{{setCardWidth()}}">
                <div class="row">
                    <div class="col-md-12">
                        <mat-card role="button" tabindex="0" class="card-section-sm" routerLink="../work-request/new">
                            <mat-card-title>Create New Request
                            </mat-card-title>
                            <mat-card-content>
                                Click on one of the three tiles above to create one of three different IT Work Requests.
                                The  <img ngSrc="assets/new-request-icon.png" alt="new work request icon" height="30"
                                width="174"> button, which appears on some
                                views, can also be used.

                            </mat-card-content>

                        </mat-card>
                    </div>
                    <div class="col-md-12">
                        <mat-card role="button" tabindex="0" class="card-section-sm" routerLink="../my-work-requests">
                            <mat-card-title>My IT Work Requests
                            </mat-card-title>
                            <mat-card-content>
                                Click on the <!--suppress HtmlUnknownTarget -->
                                <img ngSrc="assets/my-work-requests-icon.png" alt="new work request icon" height="30"
                                width="124">
                                menu item
                                to see a list of previously entered requests. From the list, you can see the
                                current status of each request and click to see details.
                                <br>
                                <br>
                                Work Requests are submitted by the initiator and then flows through the following
                                statuses:
                                <ul>
                                    <li>Draft - set by initiator.</li>
                                    <li>Submitted - set by initiator.</li>
                                    <li>Internal Review - set by administrators.</li>
                                    <li>In Progress - set by administrators.</li>
                                    <li>Completed - set by administrators.</li>
                                </ul>
                                Any changes to requests, after they are submitted, are performed by administrators or
                                project
                                managers.

                            </mat-card-content>

                        </mat-card>
                    </div>

                    <div *ngIf="(userType.isAdmin || globalService.isPMUser) && documentationLink !== ''" class="col-md-12">
                        <mat-card class="card-section-sm">
                            <mat-card-title>Additional Documentation</mat-card-title>
                            <mat-card-content>

                                <a href="{{documentationLink}}">Sharepoint Link to Front-End Documentation</a>

                            </mat-card-content>

                        </mat-card>
                    </div>
                </div>
            </div>

            <div class="col-md-6" >
                <div class="row">
                    <div class="col-md-12" *ngIf="globalService.isPMUser">
                        <mat-card role="button" tabindex="0" class="card-section-sm" routerLink="../my-pm-work-requests">
                            <mat-card-title>Projects as IT PM
                            </mat-card-title>
                            <mat-card-content>
                                If you are a project manager on a IT project, the <!--suppress HtmlUnknownTarget -->
                                <img ngSrc="assets/my-project-requests-icon.png" alt="my project requests icon" height="30"
                                width="110"> menu item will appear. This
                                view will show a list of projects assigned to you. Use this list to enter project
                                status
                                updates.

                            </mat-card-content>

                        </mat-card>
                    </div>
                    
                    <div class="col-md-12" *ngIf="globalService.isSponsorUser">
                        <mat-card role="button" tabindex="0" class="card-section-sm" routerLink="../my-sponsored-work-requests">
                            <mat-card-title>Sponsored IT Work Requests</mat-card-title>
                            <mat-card-content>
                                If you are identified as a sponsor on a work request, the <!--suppress HtmlUnknownTarget -->
                                <img ngSrc="assets/my-sponsored-requests-icon.png" alt="my sponsored requests icon" height="30"
                                width="144"> menu item
                                will appear. This view will show a list of work requests you have sponsored.
                                Use this list to get a view work requests if desired.

                            </mat-card-content>

                        </mat-card>
                    </div>
                    <div *ngIf="userType.isReadOnly" class="col-md-12">
                        <mat-card class="card-section-sm">
                            <mat-card-title>Dashboards</mat-card-title>
                            <mat-card-content>
                                The  <img ngSrc="assets/dashboard-icon.png" alt="dashboard icon" height="25"
                                width="100"> menu contains several options which provide overall statistics and high
                                level information about projects and non-project requests.
                                <br>When in a one of two dashboards, the user can click on a request and drill in
                                for more detail data.
                            </mat-card-content>

                        </mat-card>
                    </div>

                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <mat-card class="card-section-sm">
                    <mat-card-title class="first-use-title">First time use</mat-card-title>
                    <mat-card-content>
                        <br>You may see a Microsoft dialog window similar to:
                        <br>
                        <br>
                        <img class="permissions" ngSrc="assets/permissions-required.png"
                             alt="miscrosoft permissions dialog" height="300" width="293">
                        <br>
                        <br>
                        Please <b>Accept</b> this dialog to continue.
                    </mat-card-content>
                </mat-card>
            </div>


        </div>


    </mat-card-content>
</mat-card>